import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

Vue.use(Vuex);

// Create a store and register submodules
const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'prod',
  actions,
  getters,
  mutations,
  state: {
    loading: 0,
    breadcrumbs: {},
    activeRevisions: [],
  },
});

// Allow HMR on the store and submodules
if (module.hot) {
  // accept actions and mutations as hot modules
  module.hot.accept([
    './actions',
    './getters',
    './mutations',
  ], () => {
    // require the updated modules
    // swap in the new actions and mutations
    /* eslint-disable */
    store.hotUpdate({
      getters: require('./getters').default,
      actions: require('./actions').default,
      mutations: require('./mutations').default
    })
    /* eslint-enable */
  });
}

export default store;



// WEBPACK FOOTER //
// ./store/index.js